import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21173e9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkout-backdrop" }, null, -1))
const _hoisted_2 = { class: "checkout-container m-claim" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = {
  key: 0,
  class: "allowlist-message"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " The creator is finalizing eligibility requirements. Please check back later. ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "forum-reach-out"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" If you are the creator and you wish to keep this claim open "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://forum.manifold.xyz/t/manifold-claim-pages-with-allowlists-june-2023-and-earlier/",
    class: "forum-link",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "reach out to manifold"),
  /*#__PURE__*/_createTextVNode(" for help with the migration ")
], -1))

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { EyeIcon } from '@heroicons/vue/24/outline';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import BuyWithCardPage from '@/components/checkout/BuyWithCardPage.vue';
import BuyWithEthPage from '@/components/checkout/BuyWithEthPage.vue';
import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
import ChoosePaymentMethodPage from '@/components/checkout/ChoosePaymentMethodPage.vue';
import Spinner from '@/components/Spinner.vue';
import { useDates } from '@/composables/dates';
import * as telemetry from '@/lib/telemetry';
import { useClaimStore } from '@/store/claimStore';

const DEAD_ADDRESS = '0x000000000000000000000000000000000000000000000000000000000000dead';

export default /*#__PURE__*/_defineComponent({
  __name: 'BuyButton',
  setup(__props) {

_useCssVars(_ctx => ({
  "e4cb222e": (_unref(store).clientColors.themePrimary)
}))

const store = useClaimStore();
const { claimStartDate, claimEndDate, getCalendarString } = useDates();

const isModalOpen = ref(false);
const checkoutState = ref<'payment-method' | 'buy-with-eth' | 'buy-with-card' | 'success'>(
  'buy-with-eth'
);
const purchaseSucceded = ref(false);

const onSuccess = () => {
  purchaseSucceded.value = true;
};

const goToBuyWithEth = () => {
  telemetry.paymentPreview('eth');
  checkoutState.value = 'buy-with-eth';
};

const goToBuyWithCard = () => {
  telemetry.paymentPreview('card');
  checkoutState.value = 'buy-with-card';
};

const open = () => {
  store.initializeFiatPrices();

  if (store.hideCryptoPrice) {
    checkoutState.value = 'buy-with-card';
    isModalOpen.value = true;
    telemetry.paymentPreview('card');
    return;
  }

  if (store.isCrossmintVerified) {
    checkoutState.value = 'payment-method';
    isModalOpen.value = true;
    telemetry.paymentMethodsPreview();
    return;
  }

  checkoutState.value = 'buy-with-eth';
  isModalOpen.value = true;
  telemetry.paymentPreview('eth');
};

const allowlistUpdating = computed(() => {
  return store.merkleRoot === DEAD_ADDRESS;
});

const close = () => {
  isModalOpen.value = false;
  purchaseSucceded.value = false;

  // TODO Temp: Only for Redemption Codes
  store.setRedemptionCode();
};

const mintButtonLabel = computed(() => {
  if (store.isFreeClaim) {
    return 'Claim Now';
  } else {
    return 'Buy Now';
  }
});

// Need this to make sure the modal height is correct on Safari
const vh95 = ref('0px');

const setMaxHeight = () => {
  vh95.value = window.innerHeight * 0.95 + 'px';
};

onMounted(() => {
  setMaxHeight();
  window.addEventListener('resize', setMaxHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', setMaxHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "campaign-action" }, _ctx.$attrs), [
      _createVNode(_unref(TransitionRoot), { show: isModalOpen.value }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            class: "checkout",
            onClose: close
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "checkout-backdrop-enter-animation",
                "enter-from": "checkout-backdrop-enter-from-animation",
                "enter-to": "checkout-backdrop-enter-to-animation",
                leave: "checkout-backdrop-leave-animation",
                "leave-from": "checkout-backdrop-leave-from-animation",
                "leave-to": "checkout-backdrop-leave-to-animation"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "checkout-enter-animation",
                "enter-from": "checkout-enter-from-animation",
                "enter-to": "checkout-enter-to-animation",
                leave: "checkout-leave-animation",
                "leave-from": "checkout-leave-from-animation",
                "leave-to": "checkout-leave-to-animation"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(DialogPanel), {
                      class: _normalizeClass([
                'checkout-modal',
                {
                  'checkout-modal--card': checkoutState.value === 'buy-with-card',
                  success: purchaseSucceded.value,
                },
              ]),
                      style: _normalizeStyle({ 'max-height': vh95.value })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CheckoutHeader, {
                          "on-close": close,
                          success: checkoutState.value === 'success'
                        }, null, 8, ["success"]),
                        (checkoutState.value === 'payment-method')
                          ? (_openBlock(), _createBlock(ChoosePaymentMethodPage, {
                              key: 0,
                              "on-chose-method": 
                  (method) => (method === 'card' ? goToBuyWithCard() : goToBuyWithEth())
                
                            }, null, 8, ["on-chose-method"]))
                          : (checkoutState.value === 'buy-with-eth')
                            ? (_openBlock(), _createBlock(BuyWithEthPage, {
                                key: 1,
                                "go-to-pay-with-card": goToBuyWithCard,
                                "on-success": onSuccess
                              }))
                            : (checkoutState.value === 'buy-with-card')
                              ? (_openBlock(), _createBlock(BuyWithCardPage, {
                                  key: 2,
                                  "on-success": onSuccess
                                }))
                              : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["class", "style"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("button", {
        onClick: open,
        id: "buy-button",
        class: _normalizeClass(["campaign-buy-button", { 'campaign-buy-button--has-secondary': _unref(store).hasSecondary }]),
        disabled: 
        _unref(store).isLoadingWeb3State ||
        _unref(store).isDelegationLoading ||
        _unref(store).sigMintError ||
        _unref(store).isSoldOut ||
        _unref(store).status === 'not-started' ||
        _unref(store).status === 'ended' ||
        allowlistUpdating.value
      ,
        "data-testid": "buy-button"
      }, [
        (_unref(store).isLoadingWeb3State || _unref(store).isDelegationLoading)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              dark: ""
            }))
          : (_unref(store).status === 'not-started')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Drops " + _toDisplayString(_unref(getCalendarString)(_unref(claimStartDate))), 1))
            : (_unref(store).status === 'ended')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Ended " + _toDisplayString(_unref(getCalendarString)(_unref(claimEndDate))), 1))
              : (_unref(store).isSoldOut)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Sold out"))
                : (_unref(store).sigMintError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(store).sigMintErrorMessage), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(mintButtonLabel.value) + " · " + _toDisplayString(_unref(store).priceDisplayText), 1))
      ], 10, _hoisted_3)
    ], 16),
    (allowlistUpdating.value && _unref(store).status === 'active' && !_unref(store).isSoldOut)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true),
    (_unref(store).status === 'ended' && _unref(store).endDate?.getTime() === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_unref(EyeIcon), { class: "eye-icon" }),
          _hoisted_13
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})